import { gql } from "@apollo/client";

export const GET_PROFESIONALES_PAGINATED = gql`
query GetAllProfesionales(
    $skip: Int
    $take: Int
    $where: t_ProfesionalFilterInput 
    $idDelegacion: Int
) {
    allProfesionalesPaginated(skip: $skip, take: $take, where: $where, idDelegacion: $idDelegacion)
    {
        items {
            idProfesional
            nombre
            apellido
            idEspecialidad
            idTipoProfesionalNavigation {
                descripcion
            }
        }
        totalCount
    }
}`;

export const adaptProfesional = (profesional) => {
  return {
    codigoProfesional: profesional?.idProfesional,
    nombre: profesional?.nombre,
    apellido: profesional?.apellido,
    tipoProfesional: profesional?.idTipoProfesionalNavigation?.descripcion,
    idEspecialidad: profesional?.idEspecialidad
  };
};

export const adaptProfesionalesArray = (
profesionales) =>
{
  return structuredClone(profesionales)?.
  map((profesional) => adaptProfesional(profesional));
};